import { VariantType } from 'notistack';

import { AchEnrollmentStatus } from '@ocx/graphql';

import { SpireEvent } from './spire.types';
import { spireMessages } from './spire.messages';

export type SupportedAchStatus =
  | AchEnrollmentStatus.Active
  | AchEnrollmentStatus.PendingEnrollment
  | AchEnrollmentStatus.Rejected;

/**
 * Map Spire enrollment events to ACH statuses for backend mutation
 *
 * Mapping rules:
 * - Enrollment Successful → ACTIVE (user successfully enrolled)
 * - CDW Pending → PENDING_ENROLLMENT (enrollment in progress)
 * - Enrollment Failed, CDW Failed → REJECTED (enrollment rejected/failed)
 */
export const SPIRE_EVENT_TO_ACH_STATUS_MAP: Record<SpireEvent, SupportedAchStatus> = {
  'Enrollment Successful': AchEnrollmentStatus.Active,
  'CDW Pending': AchEnrollmentStatus.PendingEnrollment,
  'Enrollment Failed': AchEnrollmentStatus.Rejected,
  'CDW Failed': AchEnrollmentStatus.Rejected,
};

type SpireMessageKey = keyof typeof spireMessages;

type StatusSnackbarConfig = {
  messageKey: SpireMessageKey;
  variant: VariantType;
};

export const ACH_STATUS_SNACKBAR_CONFIG: Record<SupportedAchStatus, StatusSnackbarConfig> = {
  [AchEnrollmentStatus.Active]: {
    messageKey: 'spire:enrollment-success',
    variant: 'success',
  },
  [AchEnrollmentStatus.Rejected]: {
    messageKey: 'spire:enrollment-failed',
    variant: 'error',
  },
  [AchEnrollmentStatus.PendingEnrollment]: {
    messageKey: 'spire:enrollment-pending',
    variant: 'info',
  },
};

export const SPIRE_IFRAME_ID = 'spire-enrollment-iframe';
